import PREVIOUS_SEARCH_COUNT from './../../../constants/previous-search-count';
import baseEvents from './../config/baseEvents';
import {CABIN_CLASS_DEFAULT} from './flightSearchParams';

export const FILTER_OPTIONS = {
    STOPS: {
        ALL: 7,
    },
};

export default function FlightsFactory(
    $filter,
    $rootScope,
    flightSearchParams,
    userService,
    sessionService,
    l10nService,
    loginFactory,
    flightsApiService,
    flightsUtils
) {
    'ngInject';

            const _flights = {};
            const _params = {};

            return function(module) {

                const FREQUENT_FLIGHTS_COUNT = 3;

                // Initialize or reuse flights results for a given module
                if (!_flights[module]) {
                    _flights[module] = {};
                }
                let flights = _flights[module];


                // Initialize or reuse flights results for a given module
                if (!_params[module]) {
                    _params[module] = new flightSearchParams(module); // eslint-disable-line
                }
                const params = _params[module];

                const regionalSettings = userService.getRegionalSettings();

                const defaultFilters = {};

                let comparisonFilter = null;


                const labels = {
                    flights: {
                        items: 'Flights',
                        findItems: 'Find flights',
                        operators: 'Airlines',
                        stations: 'Airports',
                        stoppage: {
                            title: 'Stops',
                            keys: {
                                1: 'Non Stop',
                                2: '1 Stop',
                                [FILTER_OPTIONS.STOPS.ALL]: 'All',
                            },
                        },
                    },
                    trains: {
                        items: 'Trains',
                        findItems: 'Find eurostar',
                        operators: 'Operators',
                        stations: 'Stations',
                        stoppage: {
                            title: 'Changes',
                            keys: {
                                1: 'Direct',
                                2: 'Changes',
                                3: 'All',
                            },
                        },
                    },
                    ukrail: {
                    items: 'UkRail',
                    findItems: 'Find Rail',
                operators: 'Operators',
                stations: 'Stations',
                stoppage: {
                    title: 'Changes',
                    keys: {
                        1: 'Direct',
                        2: 'Changes',
                        3: 'All',
                    },
                },
            },
                };

                const EUROSTAR_BOOK_DAYS_ADVANCE = 120;
                const BOOK_MONTHS_ADVANCE = 11;

                return {
                    segmentFilterData: {},
                    options: {
                        time: [],
                    },
                    params,
                    getSearch: flightsApiService.getSearchRequestById,
                    getTimeOptions,
                    getFlights,
                    resetSegmentFilterData,
                    fetchFlights,
                    findFlights,
                    applyFilters,
                    loadMoreFlights,
                    filterBySegment,
                    getRules,
                    getTopPreviousSearches,
                    getAllPreviousSearches,
                    getFrequentFlights,
                    getModule,
                    isFlights,
                    isTrains,
                    isUkRail,
                    getLabels,
                    get showOptions() {
                        return flightsUtils.moreOptionsApplied(this.params);
                    },
                    resetParams: function() {
                        _params[module] = this.params = new Params(); // eslint-disable-line
                    },
                    getMaxBookDate,
                    applyDefaultsForRecentSearch,
                };

                function getFlights() {
                    return flights;
                }

                function resetSegmentFilterData() {
                    this.params.SegmentFilterData = [];
                    this.params.filterByGroup = [];
                }

                function fetchFlights(parameters, paramsPrepared, arrivalFlags) {
                    let request = parameters;
                    this.params.resetPagination();
                    this.params.Filters = parameters.Filters = angular.copy(defaultFilters);
                    comparisonFilter = null;

                    if (!paramsPrepared) {
                        request = this.params.getSearchRequestParams(arrivalFlags);
                    }
                    delete parameters.SearchId;
                    delete request.SearchId;

                    return flightsApiService.search(request)
                        .then(function({data}) {
                                flights = data;
                                _flights[module] = data;
                                this.params.SearchId = flights.SearchId;
                                return flights;
                            }.bind(this)
                        );
                }

                function findFlights(additionalParams) {
                    // Apply changed params
                    _.extend(this.params, additionalParams);
                    const paramsCopy = angular.copy(this.params);
                    prepareParamsForSearch.call(this, paramsCopy);
                    return fetchFlights.call(this, paramsCopy, paramsCopy.flightType);

                    function prepareParamsForSearch(parameters) {
                        parameters.CabinClass = parameters.CabinClass.value;
                        parameters.Travelers.Adult = parameters.Travelers.Adult.value;
                        parameters.Travelers.Child = parameters.Travelers.Child.value;
                        parameters.Travelers.Infant = parameters.Travelers.Infant.value;
                        parameters.PreferredAirlinecode = parameters.PreferredAirlinecode && parameters.PreferredAirlinecode.Code;
                        parameters.TotalPassengerCount = parseInt(parameters.Travelers.Adult, 10) + parseInt(parameters.Travelers.Child, 10);

                        if (parameters.flightType === 'oneway') {
                            parameters.TicketSearchSegments = [{
                                DepartureAirportCode: parameters.TicketSearchSegments[0]._departure.Code,
                                ArrivalAirportCode: parameters.TicketSearchSegments[0]._arrival.Code,
                                DepartureDate: moment(parameters.TicketSearchSegments[0]._date, regionalSettings.dateFormat)
                                    .format('YYYY-MM-DD'),
                                DepartureDayTime: parameters.TicketSearchSegments[0]._time.value,
                                IsDepartureCity: this.params.TicketSearchSegments[0]._departure.IsCity,
                                IsArrivalCity: this.params.TicketSearchSegments[0]._arrival.IsCity,
                                DayTimeFilterSource: Number(this.params.TicketSearchSegments[0]._isArrivalTime),
                            }];
                        } else {
                            parameters.TicketSearchSegments = [{
                                DepartureAirportCode: parameters.TicketSearchSegments[0]._departure.Code,
                                ArrivalAirportCode: parameters.TicketSearchSegments[0]._arrival.Code,
                                DepartureDate: moment(parameters.TicketSearchSegments[0]._date, regionalSettings.dateFormat)
                                    .format('YYYY-MM-DD'),
                                DepartureDayTime: parameters.TicketSearchSegments[0]._time.value,
                                IsDepartureCity: this.params.TicketSearchSegments[0]._departure.IsCity,
                                IsArrivalCity: this.params.TicketSearchSegments[0]._arrival.IsCity,
                                DayTimeFilterSource: this.params.TicketSearchSegments[0]._isArrivalTime ? 1 : 0,
                            }, {
                                DepartureAirportCode: parameters.TicketSearchSegments[0]._arrival.Code,
                                ArrivalAirportCode: parameters.TicketSearchSegments[0]._departure.Code,
                                DepartureDate: moment(parameters.TicketSearchSegments[1]._date, regionalSettings.dateFormat)
                                    .format('YYYY-MM-DD'),
                                DepartureDayTime: parameters.TicketSearchSegments[1]._time.value,
                                IsDepartureCity: this.params.TicketSearchSegments[0]._arrival.IsCity,
                                IsArrivalCity: this.params.TicketSearchSegments[0]._departure.IsCity,
                                DayTimeFilterSource: Number(this.params.TicketSearchSegments[0]._isArrivalTime),
                            }];
                        }
                    }

                }

                function applyFilters(filters, comparison) {

                    this.params.Filters = filters;
                    this.params.resetPagination();

                    const request = this.params.getSearchRequestParams();

                    comparisonFilter = comparison;

                    if (comparison) {
                        request.RequestedRecommendationId = comparison;
                    }
                    flightsApiService.filter(request)
                        .then(({data: {Recommendations, FilteredTotal, Filters}}) => {
                            Object.assign(flights, {
                                Recommendations,
                                FilteredTotal,
                            });
                            $rootScope.$emit(baseEvents.FLIGHT_FILTER_SEARCH_ENDED);
                            $rootScope.$broadcast(baseEvents.UPDATE_FILTERS, {
                                Filters,
                            });
                    });
                }

                function loadMoreFlights() {
                    this.params.adjustPaginationParams(flights.FilteredTotal);

                    const request = this.params.getSearchRequestParams();

                    if (comparisonFilter) {
                        request.RequestedRecommendationId = comparisonFilter;
                    }

                    flightsApiService.filter(request)
                        .then((response) => {
                            return flights.Recommendations.push.apply(
                                flights.Recommendations,
                                response.data.Recommendations
                            );
                        });
                }

                function getTimeOptions(slots) {
                    const format = regionalSettings ? regionalSettings.timeFormat : 'HH:mm';
                    const literalTypes = ['anytime', 'early', 'morning', 'afternoon', 'evening'];

                    return slots.map(function(slot, index) {
                        const dayTime = slot.DayTime.toLowerCase();
                        const label = $filter('capitalize')(dayTime);
                        const startHour = dayTime !== 'anytime'
                                ? moment(slot.From, regionalSettings.mediumTimeFormat).hour()
                                : 0;
                        let text = (_.indexOf(literalTypes, dayTime) !== -1)
                                ? l10nService.localize(label)
                                : moment(label, 'HH:mm').format(format);

                        if (dayTime === 'anytime') {
                            text += '';
                        } else if (_.indexOf(literalTypes, dayTime) !== -1) {
                            const first = moment(slot.From, regionalSettings.mediumTimeFormat).format(format);
                            const second = moment(slot.Till, regionalSettings.mediumTimeFormat).format(format);
                            text += ` (${first}-${second})`;
                        } else {
                            text += ' (+/- 1)';
                        }

                        return {
                            text,
                            value: index,
                            startHour,
                        };
                    });
                }

                function filterBySegment() {
                    this.params.resetPagination();
                    const request = this.params.getSearchRequestParams();

                    return flightsApiService.filter(request);
                }

                function getRules(parameters) {
                    const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');

                    return flightsApiService.getRules(parameters)
                        .then(({data}) => {
                            let rules = data.FlightRules;
                            const penalties = _.find(rules, (rule) => rule.Description === 'Penalties');
                            rules = _.filter(rules, (rule) => rule.Description !== 'Penalties');

                            if (penalties) {
                                rules.unshift(penalties);
                            }

                            return {isExist: data.HasTextRules, rules, culture: parameters.culture};
                        })
                        .then((rulesResponse) => {
                            if (!isReadOnlyMode) {
                                return rulesResponse;
                            }

                            return loginFactory.getLocalization(rulesResponse.culture)
                                .then((localizationResponse) => {
                                    l10nService.updateList(localizationResponse);
                                    return rulesResponse;
                                });
                        });
                }

                function getTopPreviousSearches(type) {
                    return flightsApiService.getPreviousSearches(PREVIOUS_SEARCH_COUNT.TOP, type);
                }

                function getAllPreviousSearches(type) {
                    return flightsApiService.getPreviousSearches(PREVIOUS_SEARCH_COUNT.EXTENDED, type);
                }

                function getFrequentFlights() {
                    return flightsApiService.getFrequentFlights()
                        .then(({data}) => {
                                return {
                                    from: _.sortBy(data.FromLocations, '-UsageCounter')
                                        .slice(0, FREQUENT_FLIGHTS_COUNT),
                                    to: _.sortBy(data.ToLocations, '-UsageCounter')
                                        .slice(0, FREQUENT_FLIGHTS_COUNT),
                                };
                            }
                        );
                }

                function getLabels() {
                    return labels[module];
                }

                function getModule() {
                    return module;
                }

                function isFlights() {
                    return module === 'flights';
                }

                function isTrains() {
                    return module === 'trains';
                }

                function isUkRail() {
                    return module === 'ukrail';
                }

                function getMaxBookDate() {
                    return this.isTrains()
                        ? moment().add({days: EUROSTAR_BOOK_DAYS_ADVANCE})
                        : moment().add({months: BOOK_MONTHS_ADVANCE});
                }

                function applyDefaultsForRecentSearch(data) {
                    data.CabinClass = data.CabinClass === null ? CABIN_CLASS_DEFAULT : data.CabinClass;
                    return data;
                }
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/services/flightsFactory.js